import * as crypto from 'crypto-js';
import * as CryptoJS from 'crypto-js';
import { valorTipoTelefoneEnum } from '../dominios/enum/tipo-telefone';

export class FuncoesCriptografia {


  public static Criptografar(dados) {
    let mensx = '';
    let l;
    let i;
    let j = 0;
    let ch;
    ch = 'assbdFbdpdPdpfPdAAdpeoseslsQQEcDDldiVVkadiedkdkLLnm';
    for (i = 0; i < dados.length; i++) {
      j++;
      l = (this.Asc(dados.substr(i, 1)) + (this.Asc(ch.substr(j, 1))));
      // tslint:disable-next-line: triple-equals
      if (j === 50) {
        j = 1;
      }
      if (l > 255) {
        l -= 256;
      }
      mensx += (this.Chr(l));
    }
    return mensx;
  }

  public static Descriptografar(dados) {

    let mensx = '';
    let l;
    let i;
    let j = 0;
    let ch;
    ch = 'assbdFbdpdPdpfPdAAdpeoseslsQQEcDDldiVVkadiedkdkLLnm';
    for (i = 0; i < dados.length; i++) {
      j++;
      l = (this.Asc(dados.substr(i, 1)) - (this.Asc(ch.substr(j, 1))));
      // tslint:disable-next-line: triple-equals
      if (j === 50) {
        j = 1;
      }
      if (l < 0) {
        l += 256;
      }
      mensx += (this.Chr(l));
    }
    return mensx;
  }

  public static verificarTipo(recoverPass) {

    let telefone = null;
    for (let i = 0; i < recoverPass.length; i++) {

      if (/^\d+$/.test(recoverPass[i])) {
        telefone = true;
      } else {
        telefone = false;
        break
      }
    }

    if (telefone) {
      return valorTipoTelefoneEnum.telefone;
    } else {
      return valorTipoTelefoneEnum.email
    }
  }


  public static uppercasePrimeiroCharacter(palavra: String) {
    return palavra[0].toUpperCase() + palavra.slice(1);
  }


  public static criptografar(dados) {
    return CryptoJS.AES.encrypt(JSON.stringify(dados), 'estagiarioNoComando').toString();
  }

  static descriptografar(dados) {
    try {
      const bytes = CryptoJS.AES.decrypt(dados, 'estagiarioNoComando');
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
      return null
    }
  }


  static descriptografarAllSession() {
    const arraySession = Object.entries(sessionStorage).map(storage => {
      const storageObj = { 'key': this.descriptografar(storage[0]), 'value': this.descriptografar(storage[1]) };
      return storageObj;
    });
    return arraySession;
  }

  public static descSessionByKey(key: string) {
    let resultFinal;
    const sessionDesc = this.descriptografarAllSession();
    sessionDesc.forEach(desc => {
      if (desc.key === key) {
        resultFinal = desc.value
      }
    });
    return this.tratamentoVazio(resultFinal);
  }


  static descriptografarAllLocal() {
    const arrayLocal = Object.entries(localStorage).map(storage => {
      const storageObj = {};
      storageObj[this.descriptografar(storage[0])] = this.descriptografar(storage[1]);
      return storageObj;
    });
    return arrayLocal;
  }


  public static descLocalByKey(key: string) {
    const LocalDesc = this.descriptografarAllLocal();
    return LocalDesc.find(Local => Local[key])
  }

  public static tratamentoVazio(resultFinal) {
    let tratado;
    if (resultFinal === undefined) {
      tratado = null
    } else {
      tratado = resultFinal;
    }
    return tratado;

  }



  static Asc(String) {
    return String.charCodeAt(0);
  }

  static Chr(AsciiNum) {
    return String.fromCharCode(AsciiNum)
  }


  // Função para gerar a chave randomica para o E-mail
  // tslint:disable-next-line: member-ordering
  public static GenerateKey() {
    let text = '';
    const possible = '0123456789';
    for (let i = 0; i < 5; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  public static tratarListaObjetosReptidos(listaTratata) {
    return listaTratata.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))

  }


  // // Crypt
  // public static criptografar(dados) {
  //     return crypto.AES.encrypt(JSON.stringify(dados), CHAVE_CRIPTOGRAFIA).toString();
  // }

  // // Decrypt
  // public static descriptografar(encryptedPassword) {
  //     const bytes = crypto.AES.decrypt(encryptedPassword, CHAVE_CRIPTOGRAFIA);
  //     return JSON.parse(bytes.toString(crypto.enc.Utf8));
  // }



  public static criptografiaAvancada(stringToEncrypt) {

    const rkEncryptionKey = crypto.enc.Base64.parse('u/Gu5posvwDsXUnV5Zaq4g==');
    const rkEncryptionIv = crypto.enc.Base64.parse('5D9r9ZVzEYYgha93/aUK2w==');

    const utf8Stringified = crypto.enc.Utf8.parse(stringToEncrypt);

    return crypto.AES.encrypt(utf8Stringified, rkEncryptionKey,
      { mode: crypto.mode.CBC, padding: crypto.pad.Pkcs7, iv: rkEncryptionIv }).toString();
  }




  public static descriptografiaAvancada(cryptWord) {
    if (cryptWord) {
      const rkEncryptionKey = crypto.enc.Base64.parse('u/Gu5posvwDsXUnV5Zaq4g==');
      const rkEncryptionIv = crypto.enc.Base64.parse('5D9r9ZVzEYYgha93/aUK2w==');

      return crypto.enc.Utf8.stringify(crypto.AES.decrypt(
        cryptWord,
        rkEncryptionKey,
        { mode: crypto.mode.CBC, padding: crypto.pad.Pkcs7, iv: rkEncryptionIv, }));
    }

  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/Funcoes-criptografia.ts